import { EventEmitter, ListenerFn } from 'eventemitter3';
import { MpSdk } from 'src/types';

export class Floor {
  floor: MpSdk.Floor;

  on: (type: any, callback: ListenerFn) => void;

  emit: (type: any, data?: any) => void;

  private mpSDK: MpSdk;

  constructor(mpSDK: MpSdk) {
    this.mpSDK = mpSDK;
    this.floor = mpSDK.Floor;

    const interaction = new EventEmitter();

    this.on = function (type: any, callback: ListenerFn) {
      interaction.on(type, callback);
    };

    this.emit = function (type: any, data?: unknown) {
      interaction.emit(type, data);
    };
  }

  async changeFloor(floorIndex: number, tourPlaying: any, all = false) {
    if (tourPlaying) {
      await this.mpSDK.Tour.stop();
    }

    if (all) {
      await this.floor.showAll();
    } else {
      await this.floor.moveTo(floorIndex);
    }
  }
}
